<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Kategorie</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Kategorie</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="format"
                    range
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">W header menu</label>
                <div class="col-sm-8">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="isInHeaderMenuFilter"
                        type="checkbox"
                        name="is-in-header-menu-filter"
                      />
                      <span>Tylko z flagą</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Kategorie</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddCategory" to="/categories/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>

            <div class="row">
              <div class="col-sm-6 m-b-xs">
                <div class="form-group">
                  <label class="control-label">Wpisz liczbę wierszy:</label>
                  <input
                    class="form-control inputClass rows-input"
                    type="text"
                    :value="rowsPerPage || ''"
                    @input="updateRowsPerPageInput($event.target.value)"
                    @change="setRowsPerPage"
                    @click="isSearch = false"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select
                      :value="serverOptions.rowsPerPage"
                      @change="
                        updateServerOption('rowsPerPage', $event.target.value)
                      "
                    >
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      :value="serverOptions.page"
                      @input="updateServerOption('page', $event.target.value)"
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>

                <div class="table-responsive table-search native-table-search">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="drag-column"></th>
                        <th class="index-column">#</th>
                        <th
                          v-for="header in tableHeaders"
                          :key="header.value"
                          :class="[
                            'native-header-cell',
                            { sortable: header.sortable },
                          ]"
                        >
                          <div class="native-header-content">
                            <button
                              v-if="header.sortable"
                              type="button"
                              class="native-sort-button"
                              @click="toggleSort(header.value)"
                            >
                              <span>{{ header.text }}</span>
                              <i
                                v-show="isSortedHeader(header.value)"
                                :class="sortIconClass(header.value)"
                                class="sort-icon fa"
                              ></i>
                            </button>
                            <span v-else>{{ header.text }}</span>
                            <input
                              v-if="header.search"
                              :value="searchValue[header.value] || ''"
                              class="table-search native-header-input"
                              type="text"
                              @input="
                                updateSearchValue(
                                  header.value,
                                  $event.target.value
                                )
                              "
                              @keyup="search"
                              @click.stop="isSearch = true"
                            />
                            <button
                              v-if="header.radio"
                              type="button"
                              @click="setRadioFilter"
                              class="activeFilter native-radio-filter"
                              :class="{
                                active: radioValue === true,
                                inactive: radioValue === false,
                              }"
                            >
                              <div v-if="radioValue === false">
                                <i class="fa fa-times"></i>
                              </div>
                              <div v-else-if="radioValue === true">
                                <i class="fa fa-check"></i>
                              </div>
                            </button>
                          </div>
                        </th>
                        <th class="actions-column">Akcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td
                          :colspan="tableHeaders.length + 3"
                          class="text-center"
                        >
                          Ładowanie...
                        </td>
                      </tr>
                      <tr v-else-if="!items.length">
                        <td
                          :colspan="tableHeaders.length + 3"
                          class="text-center"
                        >
                          Brak wyników
                        </td>
                      </tr>
                      <template v-else>
                        <tr
                          v-for="(item, index) in items"
                          :key="item.pk"
                          :class="['native-data-row', bodyRowClassName(item)]"
                          :draggable="canReorder"
                          @dragstart="onCategoryDragStart(index, $event)"
                          @dragenter.prevent="onCategoryDragOver(index, $event)"
                          @dragover="onCategoryDragOver(index, $event)"
                          @drop.prevent="onCategoryDrop(index, $event)"
                          @dragend="onCategoryDragEnd"
                        >
                          <td class="drag-column" @click.stop>
                            <span
                              v-if="canReorder"
                              class="drag-handle"
                              title="Przeciągnij, aby zmienić kolejność"
                            >
                              <i class="fa fa-bars"></i>
                            </span>
                          </td>
                          <td class="index-column">{{ rowNumber(index) }}</td>
                          <td>{{ item.pk }}</td>
                          <td>{{ item.title }}</td>
                          <td>{{ item.parent || "-" }}</td>
                          <td class="text-center">
                            <div v-if="!item.is_published">
                              <i class="fa fa-times"></i>
                            </div>
                            <div v-else>
                              <i class="fa fa-check"></i>
                            </div>
                          </td>
                          <td>{{ item.date_added }}</td>
                          <td>{{ item.date_modified }}</td>
                          <td>{{ item.last_modified_by }}</td>
                          <td class="actions-column" @click.stop>
                            <button
                              v-if="canChangeCategory"
                              @click.stop="openEditModal(item)"
                              class="btn btn-warning btn-xs"
                            >
                              <i class="fa fa-pencil"></i>
                            </button>
                            <button
                              v-if="canDeleteCategory"
                              @click.stop="
                                showModal = item.pk;
                                deleteName = item.title;
                              "
                              class="btn btn-danger btn-xs ml-5"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                            <button class="btn btn-primary add-info ml-5">
                              <span class="fa fa-info"></span>
                              <div class="add-info-box">
                                Data dodania: {{ item.date_added }} <br />
                                Data modyfikacji: {{ item.date_modified }}
                                <br />
                                Edytowano przez: {{ item.last_modified_by }}
                                <br />
                              </div>
                            </button>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select
                      :value="serverOptions.rowsPerPage"
                      @change="
                        updateServerOption('rowsPerPage', $event.target.value)
                      "
                    >
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      :value="serverOptions.page"
                      @input="updateServerOption('page', $event.target.value)"
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteCategories(showModal)"
    @callbackClose="showModal = false"
  />

  <teleport to="body">
    <div v-if="showEditModal" class="modal-dialog category-edit-modal">
      <div class="modal-content">
        <div class="inmodal">
          <div class="modal-header">
            <h4 class="modal-title">Edycja kategorii</h4>
          </div>
          <div class="modal-body">
            <div v-if="editLoading" class="text-center p-md">Ładowanie...</div>
            <div v-else class="form-horizontal">
              <div
                v-for="section in nameSeoSections"
                :key="section.suffix"
                class="ibox float-e-margins"
              >
                <div
                  class="ibox-title"
                  @click="toggleNameSeoSection(section.suffix)"
                >
                  <h5>{{ section.label }}</h5>
                  <span class="ibox-toggle">
                    <i :class="nameSeoChevronClass(section.suffix)"></i>
                  </span>
                </div>
                <div
                  class="ibox-content"
                  v-show="openNameSeoSections[section.suffix]"
                >
                  <div
                    v-for="field in nameSeoFields"
                    :key="field.prefix"
                    class="form-group"
                  >
                    <label class="control-label col-sm-2">
                      {{ field.label }}
                    </label>
                    <div class="col-sm-10">
                      <input
                        v-model="categoryObj[nameSeoField(field, section)]"
                        type="text"
                        class="form-control inputClass"
                        :placeholder="field.label"
                      />
                      <div
                        v-if="
                          errorsAdminData?.data?.[nameSeoField(field, section)]
                        "
                        class="has-error"
                      >
                        <span class="help-block">
                          {{
                            errorsAdminData.data[
                              nameSeoField(field, section)
                            ][0]
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Treść</label>
                    <div class="col-sm-10 QuillEditor-box">
                      <QuillEditor
                        v-if="openNameSeoSections[section.suffix]"
                        :key="`quill-${currentEditPk || 'empty'}-${
                          section.suffix
                        }`"
                        theme="snow"
                        contentType="html"
                        v-model:content="categoryObj[descriptionField(section)]"
                      />
                      <div
                        v-if="
                          errorsAdminData?.data?.[descriptionField(section)]
                        "
                        class="has-error"
                      >
                        <span class="help-block">
                          {{
                            errorsAdminData.data[descriptionField(section)][0]
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ibox float-e-margins">
                <div class="ibox-title">
                  <h5>Konfiguracja</h5>
                </div>
                <div class="ibox-content">
                  <div class="form-group">
                    <label class="control-label col-sm-2"
                      >Kategoria nadrzędna</label
                    >
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="categoryObj.parent"
                        mode="single"
                        placeholder="Kategoria nadrzędna"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="parents"
                      >
                      </Multiselect>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2"
                      >Dostępność w sklepach</label
                    >
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="countries"
                        mode="tags"
                        placeholder="Dostępność w sklepach"
                        track-by="name"
                        label="name"
                        :close-on-select="false"
                        :searchable="true"
                        :options="countryList"
                      >
                      </Multiselect>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Obrazek</label>
                    <div class="col-sm-10">
                      <picture-input
                        ref="pictureInput"
                        width="300"
                        height="300"
                        margin="16"
                        accept="image/jpeg,image/png"
                        size="10"
                        button-class="btn"
                        :prefill="categoryObj?.image"
                        :custom-strings="{
                          upload: '<h1>Uploading!</h1>',
                          drag: 'Drag & Drop',
                        }"
                        @change="onFileChange"
                      >
                      </picture-input>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-offset-2 col-sm-10">
                      <div class="checkbox checkbox-primary">
                        <label>
                          <input
                            v-model="categoryObj.is_published"
                            id="active"
                            name="active"
                            type="checkbox"
                          />
                          <span>Opublikowana</span>
                        </label>
                      </div>
                      <div
                        class="checkbox checkbox-primary category-checkbox-spacing"
                      >
                        <label>
                          <input
                            v-model="categoryObj.is_suggested_favorite"
                            id="suggested-favorite"
                            name="suggested-favorite"
                            type="checkbox"
                          />
                          <span>Sugerowana do ulubionych</span>
                        </label>
                      </div>
                      <div
                        class="checkbox checkbox-primary category-checkbox-spacing"
                      >
                        <label>
                          <input
                            v-model="categoryObj.is_in_header_menu"
                            id="is-in-header-menu"
                            name="is-in-header-menu"
                            type="checkbox"
                            :disabled="!isRootCategorySelected"
                          />
                          <span>W menu header</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-white" @click="closeEditModal">
              Anuluj
            </button>
            <button
              v-if="canChangeCategory"
              @click="saveEdit"
              :disabled="editLoading"
              class="btn btn-primary"
            >
              Zapisz
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showEditModal"
      @click="closeEditModal"
      class="modal-backdrop"
    ></div>
  </teleport>
</template>

<script>
import { computed, watch, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { categoryPermissionsConst } from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import PictureInput from "vue-picture-input";

const FILTERS_STORAGE_KEY = "catsFiltersState";
const CATEGORY_TEXT_FIELDS = [
  "title_pl",
  "title_en",
  "title_de",
  "title_cpde",
  "title_cpen",
  "title_seo_pl",
  "title_seo_en",
  "title_seo_de",
  "title_seo_cpde",
  "title_seo_cpen",
  "keywords_seo_pl",
  "keywords_seo_en",
  "keywords_seo_de",
  "keywords_seo_cpde",
  "keywords_seo_cpen",
  "description_seo_pl",
  "description_seo_en",
  "description_seo_de",
  "description_seo_cpde",
  "description_seo_cpen",
  "description_pl",
  "description_en",
  "description_de",
  "description_cpde",
  "description_cpen",
];

export default {
  name: "CategoriesList",
  components: {
    Modal,
    Multiselect,
    PictureInput,
  },
  setup() {
    const store = useStore();
    const canAddCategory = computed(() =>
      hasPermission(categoryPermissionsConst.add)
    );
    const canChangeCategory = computed(() =>
      hasPermission(categoryPermissionsConst.update)
    );
    const canDeleteCategory = computed(() =>
      hasPermission(categoryPermissionsConst.delete)
    );
    const deleteCategoriesData = computed(
      () => store.getters.getDeleteCategoriesData
    );
    const categoryData = computed(() => store.getters.getCategoryData);
    const updateCategoriesData = computed(
      () => store.getters.getUpdateCategoriesData
    );
    const categoriesData = computed(() => store.getters.getCategoriesData);
    const categoriesList = computed(() => store.getters.getCategoryParentsData);

    const tableHeaders = [
      { text: "ID", value: "pk" },
      { text: "Nazwa", value: "title", search: true, sortable: true },
      {
        text: "Kategoria nadrzędna",
        value: "parent",
        search: true,
        sortable: true,
      },
      { text: "Aktywna", value: "is_published", sortable: false, radio: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      { text: "Edytowano przez", value: "last_modified_by", sortable: true },
    ];

    const categoryObj = ref({
      title_pl: "",
      title_en: "",
      title_de: "",
      title_cpde: "",
      title_cpen: "",
      parent: [],
      is_published: false,
      is_suggested_favorite: false,
      is_in_header_menu: false,
      available_in_countries: [],
    });

    const getDefaultCategory = () => ({
      title_pl: "",
      title_en: "",
      title_de: "",
      title_cpde: "",
      title_cpen: "",
      title_seo_pl: "",
      title_seo_en: "",
      title_seo_de: "",
      title_seo_cpde: "",
      title_seo_cpen: "",
      keywords_seo_pl: "",
      keywords_seo_en: "",
      keywords_seo_de: "",
      keywords_seo_cpde: "",
      keywords_seo_cpen: "",
      description_seo_pl: "",
      description_seo_en: "",
      description_seo_de: "",
      description_seo_cpde: "",
      description_seo_cpen: "",
      description_pl: "",
      description_en: "",
      description_de: "",
      description_cpde: "",
      description_cpen: "",
      parent: null,
      image: null,
      is_published: false,
      is_suggested_favorite: false,
      is_in_header_menu: false,
      available_in_countries: [],
    });

    const items = ref([]);
    const itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const radioValue = ref("x");
    const isInHeaderMenuFilter = ref(false);
    const countries = ref([]);
    const defRowsPerPage = ref(25);
    const filterRangeDate = ref([]);
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);
    const showEditModal = ref(false);
    const editLoading = ref(false);
    const currentEditPk = ref(null);
    const parents = ref([]);
    const showErrors = ref(false);
    const searchTimer = ref(null);
    const draggedCategoryPk = ref(null);
    const dragOverCategoryPk = ref(null);
    // Names, SEO and the content are grouped per translation, like in the old
    // panel.
    const nameSeoSections = [
      { suffix: "pl", label: "Opis kategorii [pl]" },
      { suffix: "en", label: "Opis kategorii [en]" },
      { suffix: "de", label: "Opis kategorii [de]" },
      { suffix: "cpde", label: "Opis kategorii [de_de]" },
      { suffix: "cpen", label: "Opis kategorii [de_en]" },
    ];
    const nameSeoFields = [
      { prefix: "title", label: "Nazwa" },
      { prefix: "title_seo", label: "[SEO] Tytuł" },
      { prefix: "keywords_seo", label: "[SEO] Słowa kluczowe" },
      { prefix: "description_seo", label: "[SEO] Opis" },
    ];
    const nameSeoField = (field, section) =>
      field.prefix + "_" + section.suffix;
    const descriptionField = (section) => "description_" + section.suffix;
    // Only the main language starts expanded, the rest are collapsed.
    const getDefaultNameSeoSections = () =>
      Object.fromEntries(
        nameSeoSections.map((section, index) => [section.suffix, index === 0])
      );
    const openNameSeoSections = ref(getDefaultNameSeoSections());
    const toggleNameSeoSection = (suffix) => {
      openNameSeoSections.value[suffix] = !openNameSeoSections.value[suffix];
    };
    const nameSeoChevronClass = (suffix) =>
      openNameSeoSections.value[suffix]
        ? "fa fa-chevron-up"
        : "fa fa-chevron-down";
    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
      sortBy: "position",
      sortType: "asc",
    });
    // Reordering persists a new position on the category, so it is an edit.
    const canReorder = computed(() => canChangeCategory.value);
    const bodyRowClassName = (item) => {
      const classes = ["category-draggable-row"];

      if (canReorder.value) {
        classes.push("category-reorder-enabled");
      }
      if (Number(dragOverCategoryPk.value) === Number(item.pk)) {
        classes.push("drag-over-row");
      }

      return classes.join(" ");
    };

    const updateRowsPerPageInput = (value) => {
      rowsPerPage.value = value;
    };

    const updateServerOption = (key, value) => {
      serverOptions.value = {
        ...serverOptions.value,
        [key]: key === "page" || key === "rowsPerPage" ? Number(value) : value,
      };
    };

    const updateSearchValue = (key, value) => {
      searchValue.value = {
        ...searchValue.value,
        [key]: value,
      };
    };

    const selectPage = (page) => {
      serverOptions.value.page = Number(page);
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = Number(rowsPerPage.value) || 25;
      serverOptions.value.page = 1;
    };

    const toggleSort = (value) => {
      if (serverOptions.value.sortBy === value) {
        serverOptions.value.sortType =
          serverOptions.value.sortType === "asc" ? "desc" : "asc";
        return;
      }
      serverOptions.value.sortBy = value;
      serverOptions.value.sortType = "asc";
    };

    const isSortedHeader = (value) => serverOptions.value.sortBy === value;

    const sortIconClass = (value) =>
      isSortedHeader(value) && serverOptions.value.sortType === "desc"
        ? "fa-arrow-down"
        : "fa-arrow-up";

    const setBodyScrollLock = (isLocked) => {
      if (typeof document === "undefined") {
        return;
      }
      document.body.style.overflow = isLocked ? "hidden" : "";
    };

    const getCategories = async () => {
      loading.value = true;
      const sort =
        serverOptions.value.sortType === "desc"
          ? `-${serverOptions.value.sortBy}`
          : serverOptions.value.sortBy;

      const categorySearch = {
        ...searchValue.value,
      };

      if (isInHeaderMenuFilter.value) {
        categorySearch.is_in_header_menu = "true";
      }

      await store.dispatch("getCategories", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: categorySearch,
        radio: radioValue.value,
        date: filterRangeDate.value,
      });
    };

    const deleteCategories = (pk) => {
      showModal.value = false;
      if (!canDeleteCategory.value) {
        return;
      }
      store.dispatch("deleteCategories", { pk });
    };

    const isRootCategory = (parentValue) => {
      if (
        parentValue === null ||
        parentValue === undefined ||
        parentValue === ""
      ) {
        return true;
      }
      if (Array.isArray(parentValue)) {
        return parentValue.length === 0;
      }
      if (typeof parentValue === "object") {
        const parentPk = parentValue.value ?? parentValue.pk;
        return parentPk === null || parentPk === undefined || parentPk === "";
      }
      return false;
    };

    const isRootCategorySelected = computed(() =>
      isRootCategory(categoryObj.value.parent)
    );

    const ensureHeaderMenuRootConstraint = () => {
      if (
        categoryObj.value.is_in_header_menu &&
        !isRootCategorySelected.value
      ) {
        categoryObj.value.is_in_header_menu = false;
        store.dispatch("showToaster", {
          type: "error",
          content:
            'Pole "W menu header" może być ustawione tylko dla kategorii głównej.',
        });
        return false;
      }
      return true;
    };

    const normalizeParentValue = (parentValue) => {
      if (!parentValue) {
        return null;
      }
      if (Array.isArray(parentValue)) {
        if (!parentValue.length) {
          return null;
        }
        return normalizeParentValue(parentValue[0]);
      }
      if (typeof parentValue === "object") {
        return parentValue.value ?? parentValue.pk ?? null;
      }
      return parentValue;
    };

    const mapParentToOption = (parentValue) => {
      const normalizedParent = normalizeParentValue(parentValue);
      if (normalizedParent === null || normalizedParent === undefined) {
        return null;
      }

      const numericParent = Number(normalizedParent);
      const lookupValue = Number.isNaN(numericParent)
        ? normalizedParent
        : numericParent;

      const parentOption = parents.value.find(
        (option) => Number(option.value) === Number(lookupValue)
      );

      if (parentOption) {
        return parentOption.value;
      }

      return normalizedParent;
    };

    const normalizeCategoryFromApi = (rawData) => {
      const normalizeText = (value) =>
        typeof value === "string" ? value : value == null ? "" : "";

      const normalized = {
        ...getDefaultCategory(),
        ...(rawData || {}),
      };

      CATEGORY_TEXT_FIELDS.forEach((fieldName) => {
        normalized[fieldName] = normalizeText(normalized[fieldName]);
      });

      normalized.parent = mapParentToOption(normalized.parent);

      if (
        !Array.isArray(normalized.available_in_countries) &&
        typeof normalized.available_in_countries === "string"
      ) {
        try {
          normalized.available_in_countries = JSON.parse(
            normalized.available_in_countries
          );
        } catch (e) {
          normalized.available_in_countries = [];
        }
      }

      if (!Array.isArray(normalized.available_in_countries)) {
        normalized.available_in_countries = [];
      }

      normalized.is_published = Boolean(normalized.is_published);
      normalized.is_suggested_favorite = Boolean(
        normalized.is_suggested_favorite
      );
      normalized.is_in_header_menu = Boolean(normalized.is_in_header_menu);

      return normalized;
    };

    const saveEdit = () => {
      if (!canChangeCategory.value) {
        return;
      }
      if (!ensureHeaderMenuRootConstraint()) {
        return;
      }
      if (!currentEditPk.value) {
        return;
      }

      const payload = {
        ...categoryObj.value,
        pk: currentEditPk.value,
        parent: normalizeParentValue(categoryObj.value.parent) ?? "",
        available_in_countries: JSON.stringify(countries.value || []),
      };

      if (typeof payload.image === "string") {
        delete payload.image;
      }
      delete payload.subcategories;
      store.dispatch("updateCategories", payload);
    };

    const closeEditModal = () => {
      showEditModal.value = false;
      editLoading.value = false;
      currentEditPk.value = null;
      showErrors.value = false;
    };

    const openEditModal = (item) => {
      if (!canChangeCategory.value) {
        return;
      }
      if (!item?.pk) {
        return;
      }
      currentEditPk.value = item.pk;
      editLoading.value = true;
      openNameSeoSections.value = getDefaultNameSeoSections();
      categoryObj.value = getDefaultCategory();
      countries.value = [];
      showEditModal.value = true;
      store.dispatch("getCategory", { pk: item.pk });
    };

    const search = () => {
      if (searchTimer.value) {
        clearTimeout(searchTimer.value);
      }
      isSearch.value = true;
      searchTimer.value = setTimeout(() => {
        selectPage(1);
        getCategories();
        isSearch.value = false;
      }, 500);
    };

    const resetFilters = () => {
      searchValue.value = {};
      radioValue.value = "x";
      isInHeaderMenuFilter.value = false;
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "position";
      serverOptions.value.sortType = "asc";
      serverOptions.value.page = 1;
      getCategories();
    };

    const onFileChange = (image) => {
      if (image?.srcElement?.files?.[0]) {
        categoryObj.value.image = image.srcElement.files[0];
      }
    };

    const setRadioFilter = () => {
      serverOptions.value.page = 1;
      if (radioValue.value === true) {
        radioValue.value = false;
      } else if (radioValue.value === false) {
        radioValue.value = "x";
      } else {
        radioValue.value = true;
      }
    };

    const rowNumber = (index) => {
      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue =
        Number(serverOptions.value.rowsPerPage) || defRowsPerPage.value;
      return (page - 1) * rowsPerPageValue + index + 1;
    };

    const onCategoryDragStart = (index, event) => {
      if (!canReorder.value) {
        event.preventDefault();
        return;
      }

      const item = items.value[index];
      if (!item) {
        event.preventDefault();
        return;
      }

      draggedCategoryPk.value = item.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("text/plain", String(item.pk));
      }
    };

    const onCategoryDragOver = (index, event) => {
      if (!canReorder.value) {
        return;
      }

      const item = items.value[index];
      if (!item) {
        return;
      }

      event.preventDefault();
      if (event?.dataTransfer) {
        event.dataTransfer.dropEffect = "move";
      }
      dragOverCategoryPk.value = item.pk;
    };

    const onCategoryDragEnd = () => {
      draggedCategoryPk.value = null;
      dragOverCategoryPk.value = null;
    };

    const onCategoryDrop = async (index, event) => {
      if (!canReorder.value) {
        return;
      }
      event.preventDefault();
      const targetItem = items.value[index];

      if (
        !draggedCategoryPk.value ||
        !targetItem ||
        draggedCategoryPk.value === targetItem.pk
      ) {
        onCategoryDragEnd();
        return;
      }

      const fromIndex = items.value.findIndex(
        (item) => item.pk === draggedCategoryPk.value
      );
      const toIndex = index;

      if (fromIndex < 0 || toIndex < 0) {
        onCategoryDragEnd();
        return;
      }

      const [movedItem] = items.value.splice(fromIndex, 1);
      items.value.splice(toIndex, 0, movedItem);

      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue = Number(serverOptions.value.rowsPerPage) || 25;
      const newPosition = (page - 1) * rowsPerPageValue + toIndex;

      onCategoryDragEnd();

      try {
        await store.dispatch("reorderCategories", {
          pk: movedItem.pk,
          position: newPosition,
        });
        await getCategories();

        store.dispatch("showToaster", {
          type: "success",
          content: "Kolejność kategorii została zaktualizowana",
        });
      } catch (e) {
        await getCategories();
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności kategorii",
        });
      }
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
      return "";
    };

    const persistFiltersState = () => {
      localStorage.setItem(
        FILTERS_STORAGE_KEY,
        JSON.stringify({
          searchValue: searchValue.value,
          radioValue: radioValue.value,
          isInHeaderMenuFilter: isInHeaderMenuFilter.value,
          filterRangeDate: filterRangeDate.value,
          serverOptions: {
            rowsPerPage: serverOptions.value.rowsPerPage,
            sortBy: serverOptions.value.sortBy,
            sortType: serverOptions.value.sortType,
            page: serverOptions.value.page,
          },
        })
      );
    };

    const restoreFiltersState = () => {
      const rawState = localStorage.getItem(FILTERS_STORAGE_KEY);
      if (!rawState) {
        return;
      }

      try {
        const parsed = JSON.parse(rawState);
        searchValue.value = parsed.searchValue || {};
        radioValue.value = parsed.radioValue ?? "x";
        isInHeaderMenuFilter.value = Boolean(parsed.isInHeaderMenuFilter);
        filterRangeDate.value = parsed.filterRangeDate || [];
        serverOptions.value = {
          ...serverOptions.value,
          rowsPerPage:
            Number(parsed?.serverOptions?.rowsPerPage) ||
            serverOptions.value.rowsPerPage,
          sortBy: parsed?.serverOptions?.sortBy || serverOptions.value.sortBy,
          sortType:
            parsed?.serverOptions?.sortType || serverOptions.value.sortType,
          page: Number(parsed?.serverOptions?.page) || serverOptions.value.page,
        };
      } catch (e) {
        localStorage.removeItem(FILTERS_STORAGE_KEY);
      }
    };

    onMounted(() => {
      store.dispatch("getCategoryParents");
      restoreFiltersState();
      getCategories();
    });

    onBeforeUnmount(() => {
      if (searchTimer.value) {
        clearTimeout(searchTimer.value);
      }
      setBodyScrollLock(false);
    });

    watch(
      () => categoriesData.value,
      (newValue) => {
        itemsAll.value = newValue?.data?.count || 0;
        items.value = Array.isArray(newValue?.data?.results)
          ? [...newValue.data.results]
          : [];
        loading.value = false;
      }
    );

    watch(
      () => categoryData.value,
      (newValue) => {
        if (!showEditModal.value) {
          return;
        }
        if (
          newValue?.data?.pk &&
          Number(newValue.data.pk) !== currentEditPk.value
        ) {
          return;
        }
        const data = normalizeCategoryFromApi(newValue?.data);
        categoryObj.value = JSON.parse(JSON.stringify(data));
        countries.value = categoryObj.value.available_in_countries || [];
        editLoading.value = false;
      }
    );

    watch(
      () => deleteCategoriesData.value,
      (newValue) => {
        if (newValue?.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Kategoria została usunięta!",
          });
        }
        getCategories();
      }
    );

    watch(
      () => updateCategoriesData.value,
      (newValue) => {
        if (newValue?.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
          closeEditModal();
          getCategories();
          return;
        }
        if (newValue?.status >= 400) {
          store.dispatch("showToaster", {
            type: "error",
            content:
              newValue?.data?.detail ||
              "Nie udało się zapisać zmian. Sprawdź pola formularza.",
          });
        }
      }
    );

    watch(
      () => categoriesList.value,
      (newValue) => {
        const list = Array.isArray(newValue?.data) ? newValue.data : [];
        parents.value = list.map((element) => ({
          name: `[${element.pk}] ${element.title}`,
          value: element.pk,
        }));

        if (showEditModal.value) {
          categoryObj.value.parent = mapParentToOption(
            categoryObj.value.parent
          );
        }
      }
    );

    watch(
      () => categoryObj.value.parent,
      () => {
        if (
          !isRootCategorySelected.value &&
          categoryObj.value.is_in_header_menu
        ) {
          categoryObj.value.is_in_header_menu = false;
        }
      },
      { deep: true }
    );

    watch(
      () => showEditModal.value,
      (isOpen) => {
        setBodyScrollLock(isOpen);
      }
    );

    watch(
      () => serverOptions.value,
      () => {
        if (!isSearch.value) {
          getCategories();
        }
      },
      { deep: true }
    );

    watch(
      () => [
        radioValue.value,
        isInHeaderMenuFilter.value,
        filterRangeDate.value,
      ],
      () => {
        selectPage(1);
        getCategories();
      },
      { deep: true }
    );

    watch(
      () => [
        searchValue.value,
        radioValue.value,
        isInHeaderMenuFilter.value,
        filterRangeDate.value,
        serverOptions.value,
      ],
      () => {
        persistFiltersState();
      },
      { deep: true }
    );

    return {
      canAddCategory,
      canChangeCategory,
      canDeleteCategory,
      tableHeaders,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteCategories,
      deleteName,
      categoryObj,
      saveEdit,
      format,
      searchValue,
      search,
      resetFilters,
      isSearch,
      rowsPerPage,
      countryList,
      parents,
      countries,
      radioValue,
      isInHeaderMenuFilter,
      isRootCategorySelected,
      setRadioFilter,
      selectPage,
      setRowsPerPage,
      updateRowsPerPageInput,
      updateServerOption,
      updateSearchValue,
      toggleSort,
      isSortedHeader,
      sortIconClass,
      filterRangeDate,
      isFiltersOpen,
      isMainOpen,
      showEditModal,
      editLoading,
      nameSeoSections,
      nameSeoFields,
      nameSeoField,
      descriptionField,
      openNameSeoSections,
      toggleNameSeoSection,
      nameSeoChevronClass,
      showErrors,
      openEditModal,
      closeEditModal,
      onFileChange,
      rowNumber,
      canReorder,
      bodyRowClassName,
      draggedCategoryPk,
      dragOverCategoryPk,
      onCategoryDragStart,
      onCategoryDragOver,
      onCategoryDrop,
      onCategoryDragEnd,
    };
  },
  computed: {
    errorsAdminData() {
      const response = this.$store.getters.getUpdateCategoriesData;

      if (!response || typeof response.status !== "number") {
        return { data: {} };
      }

      // Show inline field errors only for validation responses.
      if (response.status < 400 || response.status >= 500) {
        return { data: {} };
      }

      const rawData =
        response.data && typeof response.data === "object" ? response.data : {};
      const normalizedData = {};

      Object.entries(rawData).forEach(([fieldName, value]) => {
        if (Array.isArray(value)) {
          normalizedData[fieldName] = value;
          return;
        }
        if (typeof value === "string") {
          normalizedData[fieldName] = [value];
        }
      });

      return { data: normalizedData };
    },
    chevronFiltersClass() {
      return this.isFiltersOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronMainClass() {
      return this.isMainOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.rows-input {
  width: 160px;
}

.native-table-search {
  margin-top: 15px;
}

.native-table-search table {
  margin-bottom: 0;
}

.native-header-cell {
  padding: 0 !important;
  min-width: 130px;
  vertical-align: top !important;
}

.native-header-content {
  position: relative;
  display: flex;
  flex-flow: column;
  padding: 10px 10px 40px;
  min-height: 58px;
}

.native-sort-button {
  position: relative;
  display: block;
  width: 100%;
  padding: 0 20px 0 0;
  border: 0;
  background: transparent;
  color: #373737;
  text-align: left;
  cursor: pointer;
}

.native-header-input {
  background: #f1f1f1;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 30px;
  padding: 0 5px;
  border: 0;
  border-top: 1px solid #e0e0e0;
}

.native-radio-filter {
  position: absolute;
  left: 50%;
  bottom: 6px;
  transform: translateX(-50%);
  margin-top: 20px;
}

.sort-icon {
  position: absolute;
  top: 0;
  right: 0;
}

.drag-column {
  width: 50px;
}

.index-column {
  width: 50px;
}

.drag-handle {
  display: inline-block;
  cursor: move;
  color: #676a6c;
}

.native-data-row.category-reorder-enabled {
  cursor: move;
}

.native-data-row.category-reorder-enabled td {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}

.native-data-row.drag-over-row {
  background-color: #f3f3f4;
}

.native-data-row.drag-over-row td {
  border-top: 2px solid #1ab394 !important;
}

.actions-column {
  width: 170px;
  white-space: nowrap;
}

.category-checkbox-spacing {
  margin-top: 12px;
}

.category-edit-modal {
  width: calc(100% - 30px);
  max-width: 1000px;
  max-height: calc(100vh - 30px);
  position: fixed;
  left: 50%;
  top: 30px;
  transform: translateX(-50%);
  z-index: 2050;
}

.category-edit-modal .modal-content {
  max-height: calc(100vh - 30px);
  display: flex;
}

.category-edit-modal .inmodal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 30px);
}

.category-edit-modal .modal-body {
  overflow-y: auto;
}

.modal-backdrop {
  z-index: 2040;
}
</style>
